import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { CORE_PAYMENT_ACTION_TYPE } from "@obg/ngx.core";
import { filter, map } from "rxjs/operators";

import { IAUI_VERIFICATION_ACTION_TYPE } from "../iaui-verification/iaui-verification.action";

import { IauiBettingLimitAction } from "./iaui-betting-limit.action";

@Injectable()
export class IauiBettingLimitEffect {
	showPopupAfterVerification$ = createEffect(() =>
		this.actions$.pipe(
			ofType(CORE_PAYMENT_ACTION_TYPE.close),
			map(() => IauiBettingLimitAction.openModal())
		)
	);

	showPopupCancelVerification$ = createEffect(() =>
		this.actions$.pipe(
			ofType(IAUI_VERIFICATION_ACTION_TYPE.closeModal),
			map((x: ActionWithPayload<string>) => x.payload),
			filter((payload) => !payload),
			map(() => IauiBettingLimitAction.openModal())
		)
	);

	constructor(private actions$: Actions) {}
}
